/**
 * @extends com.inq.flash.client.control.messagehandlers.ChatroomTransferResponse
 * @constructor
 */
com.inq.flash.client.control.messagehandlers.CMSDKTransferResponse = function() {
	this.constructor.__super__.call(this);
};
$hxClasses.extend(com.inq.flash.client.control.messagehandlers.ChatroomTransferResponse,com.inq.flash.client.control.messagehandlers.CMSDKTransferResponse,"com.inq.flash.client.control.messagehandlers.CMSDKTransferResponse")

com.inq.flash.client.control.messagehandlers.CMSDKTransferResponse.prototype.processMessage = function (message) {
	this.setAgent(
		message.getProperty(com.inq.flash.client.data.MessageFields.KEY_AGENT_ID),
		message
	);

	this.getController().onNewChatRouterMessage(message);
};
